import {
  Divider,
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { PRODUCAO_RESTRITA } from "../../shared/env";
import { authRequired } from "../../shared/keycloak";
import LimparProducaoRestrita from "./LimparProducaoRestrita";
import Logout from "./Logout";
import Status from "./Status";

const isProducaoRestrita = PRODUCAO_RESTRITA === "S";

function HeaderMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="Abrir menu"
        sx={{
          color: "white",
          height: 40
        }}
        onClick={handleClick}
      >
        <Icon>menu</Icon>
      </IconButton>
      <Menu
        id="basic-menu"
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        {[
          ["/dashboard", "dashboard", "Dashboard"],
          ["/", "list_alt", "Ocorrências"],
          ["/totalizadores", "calculate", "Totalizadores"],
          ["/pendencias", "sync_problem", "Pendências da Folha"],
          ["/ferramentas", "build", "Ferramentas"]
        ].map(([to, icon, label]) => (
          <MenuItem key={to} component={Link} to={to} onClick={handleClose}>
            <ListItemIcon>
              <Icon fontSize="small">{icon}</Icon>
            </ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
        <Divider />
        {isProducaoRestrita && <LimparProducaoRestrita onClose={handleClose} />}
        <Status onClose={handleClose} />
        {authRequired && <Logout />}
      </Menu>
    </>
  );
}

export default HeaderMenu;
